import page from 'page'
import {App} from './store'
import * as init from './init-final'

/** css,less,sass 組み込めます */
// import '../../css/style.css'
// import '../../less/style.less'
// import '../../sass/style.scss'

const routingList = []

/** ルーティング処理を貯め込む */
const registRouter = (...args) => {
	// console.info(args)
	routingList.push(args)
}

/** ルーティング開始 */
const dispatch = () => {

	/** 基本パス設定 */
	//page.base('webpack.config.jsでコンテキストパスを設定してください')

	/** 全体初期化処理 */
	page(`${App.CONTEXT_PATH}/*`, init.initialize)

	/** 登録ルーティング処理 */
	routingList.forEach( routing =>{
		page.apply(null, routing)
	} )

	/** 全体終端処理 */
	page(`${App.CONTEXT_PATH}/*`, init.finalize)

	/** DOMの読み込みが完了してから */
	$(()=>
	{
		/** ルーティング処理開始 */
		page.start({
			click: false, // Clickイベント拾わない
			popstate: false, // 履歴操作しない
			dispatch: true, // 最初のディスパッチを実行
			hashbang:false,
		})
	})
}

export {
	registRouter as regist,
	dispatch,
}